/**
 * Detects if the current device is running iOS (iPhone/iPad/iPod).
 * Covers both classic UA and modern iPad UA (which reports as MacIntel).
 */
function isIosDevice(): boolean {
  const ua = navigator.userAgent;
  return (
    /iPhone|iPod/.test(ua) ||
    /iPad/.test(ua) ||
    // Modern iPadOS reports as MacIntel but has touch support
    (/MacIntel/.test(ua) && navigator.maxTouchPoints > 1)
  );
}

/**
 * Detects if the current browser is Chrome on iOS.
 * Chrome on iOS uses "CriOS" in the user agent string.
 */
function isIosChromeOrChromeWebView(): boolean {
  const ua = navigator.userAgent;
  return /CriOS/.test(ua);
}

/**
 * On iOS non-Chrome browsers (Safari, Firefox, etc.) window.open and
 * programmatic link clicks are blocked as popups when called after an
 * async operation. For those browsers we navigate in the current tab.
 * Chrome on iOS (CriOS) handles new-tab navigation correctly, so we
 * keep the default _blank behaviour there.
 */
export function shouldOpenInCurrentTab(): boolean {
  return isIosDevice() && !isIosChromeOrChromeWebView();
}
